import React, { Component } from "react";
import { Field, reduxForm, formValueSelector, change } from "redux-form";
import { bindActionCreators } from "redux";
import { TextField, SelectField } from "redux-form-material-ui";
import { Card, CardText } from "material-ui/Card";
import { connect } from "react-redux";
import LibraryBooks from "material-ui/svg-icons/av/library-books";
import _ from "lodash";
import moment from "moment";
import {
	Table,
	TableBody,
	TableHeader,
	TableHeaderColumn,
	TableRow,
	TableRowColumn
} from "material-ui/Table";
import download from "downloadjs";
import { Link } from "react-router-dom";
import { MenuItem, RaisedButton, FlatButton } from "material-ui";
import {
	actionProcesarExcel,
	actionCreateDJ,
	actionCheckPeriodo,
	actionGetDJDetail,
	actionChangeDeclaracionJuradaProps,
	actionPrintDJ
} from "../../actions/DeclaracionJuradaActions";
import { actionGenerateExcelById } from "../../actions/GenerateExcelActions";
import {
	actionGenerarBoletaPago,
	actionDownloadFile
} from "../../actions/BoletaActions";
import { DECLARACION_JURADAS } from "../../config/RoutesConstants";
import Util, { SUCCESS, ERROR } from "../../common/Util";
import UtilPC from "../../common/UtilPC";
import VerticalListFields from "../../components/VerticalListFields/VerticalListFields";
import "./DeclaracionJuradas.css";
import AppMem from "../../common/AppMem";
import DocIcon from "material-ui/svg-icons/action/description";
import { MODE_CRU_SHOW } from "../../actions/ActionConstants";
import InfoBox from "../../components/InfoBox/InfoBox";
import {
	CONCEPTO_APORTE_SINDICAL,
	CONCEPTO_FAS,
	CONCEPTO_CONTRIBUCION_FIJA,
	ROL_ADMIN,
	ROL_EMPRESA,
	ROL_SUB_ADMIN,
	ROL_COORDINADOR,
	ROL_OPERADOR_RECAUDA,
	ROL_OPERADOR_AFFI
} from "../../common/Constants";
import Paginator from "../../components/Paginator/Paginator";

let limitePagina = 10;

class DeclaracionJuradaForm extends Component {
	constructor(props) {
		super(props);
		this.state = {
			procesado: false,
			readOnly: false,
			dataImport: null,
			page: 1,
			total: 0,
			selectedMes: false,
			selectedAnio: true,
			isNewDJ: null,
			meses: this.getMeses(moment().year()),
			anios: this.getAnios()
		};
		this.returnOnSubmit = this.returnOnSubmit.bind(this);
		this.returnDownload = this.returnDownload.bind(this);
	}

	componentWillMount() {
		if (!this.props.modeCRU) this.props.history.push(DECLARACION_JURADAS);
		if (this.props.modeCRU === MODE_CRU_SHOW) {
			this.props.actionChangeDeclaracionJuradaProps({
				pageDJDetail: 1
			});
			const declaracionJurada = this.props.declaracionJurada;
			this.props.actionGetDJDetail(
				declaracionJurada.id,
				this.props.pageDJDetail,
				limitePagina
			);
			this.props.initialize({
				anio: parseInt(declaracionJurada.year, 10),
				mes: parseInt(declaracionJurada.month, 10),
				name: declaracionJurada.company.name,
				cuit: declaracionJurada.company.cuit,
				status: declaracionJurada.status,
				notes: declaracionJurada.notes
			});
			this.setState({
				dataImport: {
					cantAfiliados: declaracionJurada.afiliateAmount,
					cantNoAfiliados: declaracionJurada.nonAfiliateAmount,
					totalBruto: declaracionJurada.totalRaw,
					totalPrimerVencimiento: declaracionJurada.contributionTotal,
					primerVencimiento: declaracionJurada.expiredDate,
					totalSegundoVencimiento: "",
					segundoVencimiento: ""
				}
			});
		} else {
			this.props.initialize({ anio: moment().year() });
		}
	}

	componentDidMount() {
		if (this.props.modeCRU !== MODE_CRU_SHOW)
			AppMem.infoDialog.open({
				title: "Información",
				messageConfirm: `Importante: a partir del mes corriente incorporamos un
					nuevo formato del archivo excel para brindarles cada día mejor servicio.
					El nuevo formato agrega una columna donde se informa el Sueldo Básico
					de cada empleado de la nómina. Descargue el nuevo formato de archivo
					y complete el proceso con la misma modalidad que los meses anteriores.
					 Ante cualquier duda, consulte el Instructivo.`,
				onAccept: () => {}
			});
	}

	componentWillReceiveProps(nextProps) {
		if (!_.isEmpty(nextProps.djDetail)) {
			let dataImportCurrent = { ...this.state.dataImport };
			let dataImport = {
				...dataImportCurrent,
				listTempDJRow: nextProps.djDetail
			};
			this.setState({
				dataImport,
				total: nextProps.djDetail.length
			});
		}
	}

	adaptFileEventToValue = delegate => e => delegate(e.target.files[0]);

	FileInput = ({
		input: { value: omitValue, onChange, onBlur, ...inputProps },
		meta: omitMeta,
		...props
	}) => (
		<input
			onChange={this.adaptFileEventToValue(onChange)}
			onBlur={this.adaptFileEventToValue(onBlur)}
			type="file"
			{...inputProps}
			{...props}
		/>
	);

	onSubmit(formValues) {
		this.props.actionProcesarExcel(formValues, this.returnOnSubmit);
	}

	returnOnSubmit(response, data) {
		if (response === SUCCESS) {
			this.setState({
				dataImport: data,
				procesado: true,
				total: data.listTempDJRow.length
			});
		} else if (response === ERROR)
			Util.showNoty(ERROR, "Error al importar los datos");
	}

	getMeses(anio) {
		let meses = UtilPC.menuItemsMonths();
		if (anio === moment().year()) return _.slice(meses, 0, moment().month());
		return meses;
	}

	getAnios() {
		let anios = [];
		let anioActual = moment().year();
		for (let i = anioActual; i >= 2013; i--) {
			anios.push(<MenuItem value={i} key={i} primaryText={i} />);
		}
		return anios;
	}

	renderBodyRows(afiliadosList) {
		return _.map(
			afiliadosList.slice(
				this.state.page * limitePagina - limitePagina,
				this.state.page * limitePagina
			),
			(afiliado, i) => {
				return (
					<TableRow key={i} style={{ height: "16px", fontSize: "12px" }}>
						<TableRowColumn style={{ marginLeft: 15 }}>
							{afiliado.cuil}
						</TableRowColumn>
						<TableRowColumn style={{ marginLeft: 20 }}>
							{afiliado.apellido}
						</TableRowColumn>
						<TableRowColumn style={{ marginLeft: 20 }}>
							{afiliado.nombre}
						</TableRowColumn>
						<TableRowColumn style={{ marginLeft: 20 }}>
							{afiliado.esAfiliado ? "SI" : "NO"}
						</TableRowColumn>
						<TableRowColumn style={{ marginLeft: 20 }}>
							{`$ ${Util.formatDouble(afiliado.bruto)}`}
						</TableRowColumn>
						<TableRowColumn style={{ marginLeft: 20 }}>
							{`$ ${Util.formatDouble(afiliado.basicSalary)}`}
						</TableRowColumn>
						<TableRowColumn style={{ marginLeft: 20 }}>
							{`$ ${Util.formatDouble(
								this.getMontoConcepto(
									afiliado.listTempDJConcepto,
									CONCEPTO_APORTE_SINDICAL
								)
							)}`}
						</TableRowColumn>
						<TableRowColumn style={{ marginLeft: 20 }}>
							{`$ ${Util.formatDouble(
								this.getMontoConcepto(afiliado.listTempDJConcepto, CONCEPTO_FAS)
							)}`}
						</TableRowColumn>
						<TableRowColumn style={{ marginLeft: 20 }}>
							{`$ ${Util.formatDouble(
								this.getMontoConcepto(
									afiliado.listTempDJConcepto,
									CONCEPTO_CONTRIBUCION_FIJA
								)
							)}`}
						</TableRowColumn>
					</TableRow>
				);
			}
		);
	}

	onPressGenerateBoleta() {
		this.props.actionGenerarBoletaPago(this.returnOnConfirm);
	}

	onConfirm() {
		this.props.actionCreateDJ(
			this.state.dataImport.id,
			this.state.isNewDJ,
			this.props.formValues.mes,
			this.props.formValues.anio,
			this.returnOnConfirm
		);
	}

	returnOnConfirm = ruta => {
		this.setState({ readOnly: true });
		this.downloadFile(ruta.nombreArchivo);
	};

	downloadFile(fileName) {
		this.props.actionDownloadFile(fileName, this.returnDownload.bind(this));
	}

	returnDownload(blob) {
		let nombreArchivo =
			this.props.formValues.anio + "-" + this.props.formValues.mes + "-UPSRA";
		download(blob, nombreArchivo);
	}

	onClickPrint() {
		this.props.actionPrintDJ(
			this.props.declaracionJurada.id,
			this.downloadFile.bind(this)
		);
	}

	onChangePage = page => {
		if (this.props.modeCRU === MODE_CRU_SHOW) {
			this.props.actionChangeDeclaracionJuradaProps({
				pageDJDetail: page
			});
			this.props.actionGetDJDetail(
				this.props.declaracionJurada.id,
				page,
				limitePagina
			);
		} else this.setState({ page: page });
	};

	onChangeMes = (event, key) => {
		this.setState({ selectedMes: true });
		if (this.state.selectedAnio)
			this.props.actionCheckPeriodo(
				key,
				this.props.formValues.anio,
				this.callbackCheckPeriodo
			);
	};

	onChangeAnio = (event, key) => {
		this.setState({ selectedAnio: true, meses: this.getMeses(key) });
		if (this.state.selectedMes)
			this.props.actionCheckPeriodo(
				this.props.formValues.mes,
				key,
				this.callbackCheckPeriodo
			);
	};

	onCheckPeriodoInfo = () => {
		this.setState({ selectedMes: false });
		this.props.dispatch(change("DeclaracionJuradaForm", "mes", null));
	};

	callbackCheckPeriodo = (fixedContribution, periodo) => {
		if (!fixedContribution)
			AppMem.infoDialog.open({
				title: "Declaración Jurada",
				messageConfirm: `Si desea presentar una DDJJ de este período,
comuníquese con nuestro sector Recaudaciones al teléfono (11)5263-7348 Interno 118
o vía correo electrónico recaudaciones@upsra.org.ar`,
				onAccept: this.onCheckPeriodoInfo
			});
		else if (periodo)
			AppMem.confirmDialog.open({
				title: "Declaración Jurada",
				messageConfirm:
					"Existe una declaración jurada en este período. ¿Desea ingresar una Declaración Jurada adicional a la existente?",
				onAccept: () => this.setState({ isNewDJ: false }),
				onDecline: () => this.props.history.push(DECLARACION_JURADAS)
			});
		else this.setState({ isNewDJ: true });
	};
	renderPaginator = () => {
		return (
			<Paginator
				page={
					this.props.modeCRU === MODE_CRU_SHOW
						? this.props.pageDJDetail
						: this.state.page
				}
				pageLimit={limitePagina}
				total={
					this.props.modeCRU === MODE_CRU_SHOW
						? this.props.totalDJDetail
						: this.state.total
				}
				onChangePage={this.onChangePage}
			/>
		);
	};
	getMontoConcepto(listConpetos, tipo) {
		let concepto = listConpetos.find(c => {
			return c.concepto.id === tipo;
		});
		return concepto ? concepto.monto : 0;
	}
	generateExcelDJDetail() {
		this.props.actionGenerateExcelById(
			"ddjjDetails",
			this.props.declaracionJurada.id,
			this.returnDownloadExcel.bind(this)
		);
	}
	returnDownloadExcel(type, blob) {
		let nombreArchivo = "DDJJ - " + this.props.declaracionJurada.id;
		download(blob, nombreArchivo);
	}
	render() {
		const modeShow = this.props.modeCRU;
		let styleVerticalList =
			modeShow === MODE_CRU_SHOW ? " columns-half" : "columns-row-between";
		const { handleSubmit, rol } = this.props;
		const print =
			rol === ROL_ADMIN ||
			rol === ROL_SUB_ADMIN ||
			rol === ROL_COORDINADOR ||
			rol === ROL_EMPRESA ||
			rol === ROL_OPERADOR_RECAUDA ||
			rol === ROL_OPERADOR_AFFI;
		const ddjjPrint =
			rol === ROL_ADMIN ||
			rol === ROL_SUB_ADMIN ||
			rol === ROL_COORDINADOR ||
			rol === ROL_OPERADOR_RECAUDA ||
			rol === ROL_OPERADOR_AFFI;
		return (
			<div className="center">
				<Card className="card">
					{UtilPC.renderCardTitleCRU(this.props.modeCRU, "Declaración Jurada")}
					<CardText>
						<form>
							{modeShow === MODE_CRU_SHOW ? (
								<VerticalListFields
									titleText="Datos de la Declaración Jurada"
									titleClass="title-papercard-primary"
									paperClass="papercard top20"
									contentClass="content-papercard-around"
								>
									<div className="columns-row-around">
										<div className="columns-row-simple ">
											<div className="columns-column-simple ">
												<Field
													name="name"
													component={TextField}
													floatingLabelText="Nombre"
													floatingLabelFixed
													disabled
													fullWidth
												/>
											</div>
											<div className="columns-column-simple ">
												<Field
													name="cuit"
													component={TextField}
													floatingLabelText="CUIT"
													floatingLabelFixed
													disabled
												/>
												<Field
													name="status"
													component={TextField}
													floatingLabelText="Estado"
													floatingLabelFixed
													disabled
													className="left20 redColor"
												/>
											</div>
											<div className="columns-column-simple ">
												<Field
													name="notes"
													component={TextField}
													floatingLabelText="Comentarios"
													floatingLabelFixed
													disabled
													fullWidth
													multiLine
													rows={2}
												/>
											</div>
										</div>
										<div className="align-center">
											{print ? (
												<RaisedButton
													label="Imprimir"
													primary
													style={{ marginTop: 22, marginBottom: 20 }}
													onClick={this.onClickPrint.bind(this)}
												/>
											) : null}
											{ddjjPrint ? (
												<RaisedButton
													label="Generar Excel DDJJ"
													icon={<LibraryBooks />}
													primary
													style={{
														marginTop: 22,
														marginBottom: 20,
														marginLeft: 10
													}}
													onClick={this.generateExcelDJDetail.bind(this)}
												/>
											) : null}
											<InfoBox
												Icon={DocIcon}
												color="#245688"
												title="D.J."
												value={
													this.props.declaracionJurada.prefix +
													"-" +
													this.props.declaracionJurada.number
												}
											/>
										</div>
									</div>
								</VerticalListFields>
							) : null}
							<div className={styleVerticalList}>
								<VerticalListFields
									titleText="Período"
									titleClass="title-papercard-primary"
									paperClass="papercard top20"
									contentClass="content-papercard-around"
								>
									<div className="columns-row-between">
										<Field
											name="mes"
											component={SelectField}
											floatingLabelText="Mes"
											onChange={this.onChangeMes}
											disabled={
												this.state.readOnly ||
												this.state.procesado ||
												modeShow === MODE_CRU_SHOW
											}
										>
											{this.state.meses}
										</Field>
										<Field
											name="anio"
											component={SelectField}
											floatingLabelText="Año"
											onChange={this.onChangeAnio}
											disabled={
												this.state.readOnly ||
												this.state.procesado ||
												modeShow === MODE_CRU_SHOW
											}
										>
											{this.state.anios}
										</Field>
									</div>
								</VerticalListFields>
								{modeShow !== MODE_CRU_SHOW ? (
									<VerticalListFields
										titleText="Importar Archivo"
										titleClass="title-papercard-primary"
										paperClass="papercard top20 left20"
										contentClass="content-papercard-around flex-column"
									>
										<Field
											name="archivoExcel"
											component={this.FileInput}
											disabled={
												this.state.readOnly ||
												(this.props.formValues.mes && this.props.formValues.anio
													? false
													: true)
											}
											accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
											//validate={required}
										/>
										<RaisedButton
											label="Procesar"
											disabled={
												this.state.readOnly ||
												(this.props.formValues.mes &&
												this.props.formValues.anio &&
												this.props.formValues.archivoExcel
													? false
													: true)
											}
											primary
											style={{ margin: 5 }}
											onClick={handleSubmit(this.onSubmit.bind(this))}
										/>
									</VerticalListFields>
								) : null}
							</div>
						</form>
						{this.state.procesado || modeShow === MODE_CRU_SHOW ? (
							<VerticalListFields
								titleText="Datos Importados"
								titleClass="title-papercard-primary"
								paperClass="papercard top20"
								contentClass="content-papercard-around"
							>
								<div className="columns-row-around">
									<TextField
										hintText="Cantidad de Afiliados"
										floatingLabelText="Cantidad de Afiliados"
										disabled
										value={this.state.dataImport.cantAfiliados}
									/>
									<TextField
										hintText="Cantidad de No Afiliados"
										floatingLabelText="Cantidad de No Afiliados"
										disabled
										value={this.state.dataImport.cantNoAfiliados}
									/>
								</div>
								<div>
									<Table selectable={false}>
										<TableHeader
											displaySelectAll={false}
											adjustForCheckbox={false}
										>
											<TableRow>
												<TableHeaderColumn>Cuil</TableHeaderColumn>
												<TableHeaderColumn>Apellidos</TableHeaderColumn>
												<TableHeaderColumn>Nombres</TableHeaderColumn>
												<TableHeaderColumn>Afiliado</TableHeaderColumn>
												<TableHeaderColumn>Rem. Bruta</TableHeaderColumn>
												<TableHeaderColumn>Aporte Sindical</TableHeaderColumn>
												<TableHeaderColumn>F.A.S.</TableHeaderColumn>
												<TableHeaderColumn>Suplemento 1</TableHeaderColumn>
											</TableRow>
										</TableHeader>
										<TableBody stripedRows displayRowCheckbox={false}>
											{!_.isEmpty(this.state.dataImport.listTempDJRow)
												? this.renderBodyRows(
														this.state.dataImport.listTempDJRow
													)
												: null}
										</TableBody>
									</Table>
									{!_.isEmpty(this.state.dataImport.listTempDJRow)
										? this.renderPaginator()
										: ""}
								</div>
								<div className="columns-row-between columns-half">
									<TextField
										hintText="Total Remuneración Bruta"
										floatingLabelText="Total Remuneración Bruta"
										disabled
										value={`$ ${Util.formatDouble(
											this.state.dataImport.totalBruto
										)}`}
									/>
								</div>
								<div className="columns-row-between columns-half">
									<TextField
										hintText="Total Pagar"
										floatingLabelText="Total Pagar"
										disabled
										value={`$ ${Util.formatDouble(
											this.state.dataImport.totalPrimerVencimiento
										)}`}
									/>
									<TextField
										hintText="1er Vencimiento"
										floatingLabelText="1er Vencimiento"
										disabled
										value={Util.formatDateToShowNotHour(
											this.state.dataImport.primerVencimiento
										)}
									/>
								</div>
							</VerticalListFields>
						) : null}
						<div className="top20 text-right">
							<Link to={DECLARACION_JURADAS}>
								<FlatButton
									label={
										this.state.readOnly || modeShow === MODE_CRU_SHOW
											? "Volver"
											: "Cancelar"
									}
									style={{ margin: 5 }}
								/>
							</Link>
							{modeShow !== MODE_CRU_SHOW ? (
								<RaisedButton
									label="Confirmar DDJJ"
									disabled={this.state.readOnly || !this.state.procesado}
									primary
									style={{ margin: 5 }}
									onClick={this.onConfirm.bind(this)}
								/>
							) : null}
						</div>
					</CardText>
				</Card>
			</div>
		);
	}
}

function mapStateToProps(store) {
	const selector = formValueSelector("DeclaracionJuradaForm");
	return {
		declaracionJurada: store.declaracionJurada.declaracionJurada,
		modeCRU: store.declaracionJurada.modeCRU,
		djDetail: store.declaracionJurada.djDetail,
		pageDJDetail: store.declaracionJurada.pageDJDetail,
		totalDJDetail: store.declaracionJurada.totalDJDetail,
		rol: store.app.rol,
		formValues: selector(store, "mes", "anio", "archivoExcel")
	};
}
function mapDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			actionProcesarExcel,
			actionGenerarBoletaPago,
			actionDownloadFile,
			actionCreateDJ,
			actionCheckPeriodo,
			actionGetDJDetail,
			actionChangeDeclaracionJuradaProps,
			actionPrintDJ,
			actionGenerateExcelById
		},
		dispatch
	);
}
export default reduxForm({
	form: "DeclaracionJuradaForm"
})(connect(mapStateToProps, mapDispatchToProps)(DeclaracionJuradaForm));



// WEBPACK FOOTER //
// ./src/screens/DeclaracionJurada/DeclaracionJuradaForm.js